import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { detectReferralSource } from "./lib/analytics";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Diensten from "./pages/Diensten";
import ServiceDetail from "./pages/ServiceDetail";
import Over from "./pages/Over";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import Prijzenlijst from "./pages/Prijzenlijst";
import Portfolio from "./pages/Portfolio";
import DetailingAanHuis from "./pages/DetailingAanHuis";
import Apeldoorn from "./pages/Apeldoorn";
import Zutphen from "./pages/Zutphen";
import Raalte from "./pages/Raalte";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import WhatsAppButton from "./components/WhatsAppButton";
import { OfferteProvider } from "./context/OfferteContext";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  useEffect(() => { detectReferralSource(); }, []);
  return (
    <HelmetProvider>
      <div className="App bg-[#0a0a0b] min-h-screen">
        <BrowserRouter>
          <LanguageProvider>
          <OfferteProvider>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/diensten" element={<Diensten />} />
              <Route path="/diensten/:slug" element={<ServiceDetail />} />
              <Route path="/prijzenlijst" element={<Prijzenlijst />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/detailing-aan-huis" element={<DetailingAanHuis />} />
              <Route path="/detailing-apeldoorn" element={<Apeldoorn />} />
              <Route path="/detailing-zutphen" element={<Zutphen />} />
              <Route path="/detailing-raalte" element={<Raalte />} />
              <Route path="/over" element={<Over />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />

              {/* English routes */}
              <Route path="/en" element={<Home />} />
              <Route path="/en/services" element={<Diensten />} />
              <Route path="/en/services/:slug" element={<ServiceDetail />} />
              <Route path="/en/pricing" element={<Prijzenlijst />} />
              <Route path="/en/projects" element={<Portfolio />} />
              <Route path="/en/mobile-detailing" element={<DetailingAanHuis />} />
              <Route path="/en/detailing-apeldoorn" element={<Apeldoorn />} />
              <Route path="/en/detailing-zutphen" element={<Zutphen />} />
              <Route path="/en/detailing-raalte" element={<Raalte />} />
              <Route path="/en/about" element={<Over />} />
              <Route path="/en/reviews" element={<Reviews />} />
              <Route path="/en/contact" element={<Contact />} />

              {/* Catch-all 404 — noindex, prevents soft-404 junk indexing */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <WhatsAppButton />
          </OfferteProvider>
          </LanguageProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
